import { Injectable } from "@angular/core";
import { UsersColumnName } from "@helper/types/user";

@Injectable()
export class UsersColumnsService {
	private key = "nkfo.users.columns";

	public save(columns: UsersColumnName[]): void {
		localStorage.setItem(this.key, columns.join("."));
	}

	public restore(): UsersColumnName[] {
		const str = localStorage.getItem(this.key);
		return (str !== null ? str.split(".") : [
			"clientName",
			"clientLogin",
			"clientEmail",
			"clientTypeName",
			"clientPhoneNumber",
			"clientTypeDescription",
			"clientSupplierName",
			"clientBlocked",
			"clientDateAdd"
		]) as UsersColumnName[];
	}
}
